import { get } from 'lodash'
import { getUserData } from "../../../services/API";

export default function getTeacherName() {
  const userData = getUserData();
  const firstName = get(userData, 'sessionData.authData.attributes.custom:firstName')
  const lastName = get(userData, 'sessionData.authData.attributes.custom:lastName')
  return `${firstName} ${lastName}`
}